<script>
import {
  Line,
  Bar,
} from 'vue-chartjs';

export default {
  extends: Bar,
  props: {
    pro_unit_code: Array,
    pro_unit_code_ob: Object,
  },
  data() {
    return {
      options: {
        responsive: true,
        title: {
          display: true,
          text: '',
          fontSize: 18,
        },
        scales: {
          yAxes: [{
            ticks: {
              suggestedMin: 0,
            },
          }],
        },
      },
    };
  },
  computed: {
    allwaysAns: {
      get() {
        return this.$store.state.exam.allwaysAns;
      },
    },
    chartdata() {
      if (this.allwaysAns === true) {
        const data = {
          labels: this.pro_unit_code,
          title: '',
          datasets: [{
            label: '總題數',
            backgroundColor: '#007bff',
            borderColor: '#007bff',
            fill: flase,
            data: [],
          }],
        };
        this.pro_unit_code.forEach((e) => {
          data.datasets[0].data.push(this.pro_unit_code_ob[e].count);
        });
        // this.options.title.text = '題型分析';
        return data;
      }
      const data = {
        labels: this.pro_unit_code,
        title: '',
        datasets: [
          {
            uid: 'count',
            label: '總題數',
            backgroundColor: '#007bff',
            borderColor: '#007bff',
            fill: false,
            lineTension: 0,
            data: [],
          },
          // {
          //   uid: 'correct',
          //   // type: 'line',
          //   label: '答對題數',
          //   backgroundColor: '#dc3545',
          //   borderColor: '#dc3545',
          //   fill: false,
          //   lineTension: 0,
          //   data: [],
          // },
          {
            uid: 'correct2',
            type: 'line',
            label: '答對題數',
            backgroundColor: '#17a2b8',
            borderColor: '#17a2b8',
            fill: false,
            lineTension: 0,
            data: [],
          },
        ],
      };
      this.pro_unit_code.forEach((e) => {
        data.datasets.forEach((j) => {
          if (j.uid === 'count') {
            j.data.push(this.pro_unit_code_ob[e].count);
          } else {
            j.data.push(this.pro_unit_code_ob[e].correct);
          }
        });
        // data.datasets[1].data.push(this.pro_unit_code_ob[e].correct);
        // data.datasets[0].data.push(this.pro_unit_code_ob[e].count);
      });
      // this.options.title.text = '弱點分析';
      return data;
    },
  },
  mounted() {
    // if (this.allwaysAns === true) {
    //   this.chartdata.datasets.splice(0, 1);
    // }
    // this.pro_unit_code.forEach((e) => {
    //   if (this.allwaysAns === true) {
    //     this.chartdata.datasets[0].data.push(this.pro_unit_code_ob[e].count);
    //     this.options.title.text = '題型分析';
    //   } else {
    //     this.chartdata.datasets[0].data.push(this.pro_unit_code_ob[e].correct);
    //     this.chartdata.datasets[1].data.push(this.pro_unit_code_ob[e].count);
    //     this.options.title.text = '弱點分析';
    //   }
    // });
    if (this.allwaysAns === true) {
      this.options.title.text = '題型分析';
    } else {
      this.options.title.text = '落點分析';
    }
    this.renderChart(this.chartdata, this.options);
  },
};

</script>
